// Раздел «Операции» (перенос из старого Office): заявки поставщикам (П) — все/услуги, дефектный акт,
// заявки на продукты, Fulfillment. Бэкенд — office_api/office_port/areas/operations/.
// «Заявки поставщикам SR», гарантия, планирование материалов, заявки проектировщиков, канбан — уже были в My Space.

export const pages = {
  officeOpsPrAll: "/office/operations/provider-requests/all",
  officeOpsPrService: "/office/operations/provider-requests/service",
  officeOpsDefectChecks: "/office/operations/defect/checks",
  officeOpsDefectLinks: "/office/operations/defect/links",
  officeOpsDefectActs: "/office/operations/defect/acts/1",
  officeOpsDefectApp: "/office/operations/defect/acts/2",
  officeOpsDefectSmeta: "/office/operations/defect/smeta",
  officeOpsProductKitchenAll: "/office/operations/product-requests/kitchen_all",
  officeOpsProductPayedHalf: "/office/operations/product-requests/payed_half",
  officeOpsProductSend: "/office/operations/product-requests/send",
  officeOpsFfRequests: "/office/operations/ff/requests",
  // Гарантия по статусам (Office: guarantee-loader/grt_status_id/N)
  officeOpsGrtAll: "/office/operations/warranty/0",
  officeOpsGrtCreated: "/office/operations/warranty/1",
  officeOpsGrtFromClients: "/office/operations/warranty/-1",
  officeOpsGrtFeedback: "/office/operations/warranty/100",
  officeOpsGrtDa: "/office/operations/warranty/200",
  officeOpsGrtInWork: "/office/operations/warranty/300",
  officeOpsGrtDone: "/office/operations/warranty/500",
  officeOpsGrtRefused: "/office/operations/warranty/600",
  officeOpsGrtFinished: "/office/operations/warranty/700",
  officeOpsAttorney: "/office/operations/attorney",
};

// Маршрутный лист экспедитора — без входа (layout «check» + routeHead: App не проверяет авторизацию), по тем же адресам,
// что в Office: ссылку формирует база (read_expeditor_link → /provider-request/expeditor-list/expeditor_link/<hash>).
const EXPEDITOR = { layout: "check", routeHead: "provider-request/expeditor-", title: "Маршрутный лист" };

export const routes = [
  {
    path: "/office/operations/provider-requests/:type(all|service)",
    name: "officeOpsPrList",
    meta: { layout: "main", title: "Заявки поставщикам" },
    component: () => import("@/views/office/operations/providerRequests/PrRemontList.vue"),
  },
  {
    path: "/office/operations/defect/checks",
    name: "officeOpsDefectChecks",
    meta: { layout: "main", title: "Чеклисты и параметры" },
    component: () => import("@/views/office/operations/defect/DefectChecks.vue"),
  },
  {
    path: "/office/operations/defect/links",
    name: "officeOpsDefectLinks",
    meta: { layout: "main", title: "Чеклисты застройщика" },
    component: () => import("@/views/office/operations/defect/DefectLinks.vue"),
  },
  {
    path: "/office/operations/defect/acts/:defect_type_id(\\d+)",
    name: "officeOpsDefectActs",
    meta: { layout: "main", title: "Дефектные акты" },
    component: () => import("@/views/office/operations/defect/DefectActs.vue"),
  },
  {
    path: "/office/operations/defect/act/:defect_id(\\d+)",
    name: "officeOpsDefectDetail",
    meta: { layout: "main", title: "Дефектный акт" },
    component: () => import("@/views/office/operations/defect/DefectDetail.vue"),
  },
  {
    path: "/office/operations/defect/smeta",
    name: "officeOpsDefectSmeta",
    meta: { layout: "main", title: "Консолидированные сметы" },
    component: () => import("@/views/office/operations/defect/DefectSmeta.vue"),
  },
  {
    path: "/office/operations/product-requests/:status(kitchen_all|payed_half|send)",
    name: "officeOpsProductRequests",
    meta: { layout: "main", title: "Заявки на продукты" },
    component: () => import("@/views/office/operations/products/ProductRequests.vue"),
  },
  {
    path: "/office/operations/ff/requests",
    name: "officeOpsFfRequests",
    meta: { layout: "main", title: "Fulfillment: заявки поставщикам" },
    component: () => import("@/views/office/operations/ff/FfRequests.vue"),
  },
  {
    path: "/office/operations/warranty/:grt_status_id(-?\\d+)",
    name: "officeOpsWarrantyStatus",
    meta: { layout: "main", title: "Гарантия" },
    component: () => import("@/views/office/operations/warranty/WarrantyByStatus.vue"),
  },
  {
    path: "/office/operations/attorney",
    name: "officeOpsAttorney",
    meta: { layout: "main", title: "Формирование доверенности" },
    component: () => import("@/views/office/operations/attorney/AttorneyCreate.vue"),
  },
  {
    path: "/provider-request/expeditor-list/expeditor_link/:expeditor_link",
    name: "officeOpsExpeditorList",
    meta: EXPEDITOR,
    component: () => import("@/views/office/operations/expeditor/ExpeditorList.vue"),
  },
  {
    path: "/provider-request/expeditor-item/expeditor_link/:expeditor_link/pr_link/:pr_link",
    name: "officeOpsExpeditorItem",
    meta: EXPEDITOR,
    component: () => import("@/views/office/operations/expeditor/ExpeditorItem.vue"),
  },
  {
    path: "/provider-request/expeditor-item/expeditor_link/:expeditor_link/pr_link_multiple/:pr_link_multiple",
    name: "officeOpsExpeditorItemMultiple",
    meta: EXPEDITOR,
    component: () => import("@/views/office/operations/expeditor/ExpeditorItem.vue"),
  },
  {
    path: "/provider-request/expeditor-receive/expeditor_link/:expeditor_link/pr_link/:pr_link",
    name: "officeOpsExpeditorReceive",
    meta: EXPEDITOR,
    props: { receive: true },
    component: () => import("@/views/office/operations/expeditor/ExpeditorItem.vue"),
  },
  {
    path: "/provider-request/expeditor-receive/expeditor_link/:expeditor_link/pr_link_multiple/:pr_link_multiple",
    name: "officeOpsExpeditorReceiveMultiple",
    meta: EXPEDITOR,
    props: { receive: true },
    component: () => import("@/views/office/operations/expeditor/ExpeditorItem.vue"),
  },
];
